import { mugshotSrc } from "../utils/utils";
export const players = {
    "00-0032772": {
        team: "away_team",
        firstname: "Ryan",
        lastname: "Smith",
        jersey_number: 29,
        position: "CB",
        position_group: "DB",
    },
    "00-0032637": {
        team: "away_team",
        firstname: "Andrew",
        lastname: "Adams",
        jersey_number: 26,
        position: "SS",
        position_group: "DB",
    }, "00-0031016": {
        team: "away_team",
        firstname: "Ross",
        lastname: "Cockrell",
        jersey_number: 43,
        position: "CB",
        position_group: "DB",
    },
    "00-0034386": {
        team: "away_team",
        firstname: "Justin",
        lastname: "Watson",
        jersey_number: 17,
        position: "WR",
        position_group: "WR",
    },
    "00-0036427": {
        team: "away_team",
        firstname: "Tyler",
        lastname: "Johnson",
        jersey_number: 18,
        position: "WR",
        position_group: "WR",
    },
    "00-0030382": {
        team: "away_team",
        firstname: "Kevin",
        lastname: "Minter",
        jersey_number: 51,
        position: "ILB",
        position_group: "LB",
    },
    "00-0033006": {
        team: "away_team",
        firstname: "Jaydon",
        lastname: "Mickens",
        jersey_number: 85,
        position: "WR",
        position_group: "WR",
    },
    "00-0036045": {
        team: "away_team",
        firstname: "Cam",
        lastname: "Gill",
        jersey_number: 49,
        position: "OLB",
        position_group: "LB",
    },
    "00-0033421": {
        team: "away_team",
        firstname: "Antony",
        lastname: "Auclair",
        jersey_number: 82,
        position: "TE",
        position_group: "TE",
    },
    "00-0035254": {
        team: "away_team",
        firstname: "Anthony",
        lastname: "Nelson",
        jersey_number: 98,
        position: "OLB",
        position_group: "LB",
    },
    "00-0036434": {
        team: "away_team",
        firstname: "Chapelle",
        lastname: "Russell",
        jersey_number: 53,
        position: "LB",
        position_group: "LB",
    },
    "00-0029895": {
        team: "away_team",
        firstname: "Ryan",
        lastname: "Jensen",
        jersey_number: 66,
        position: "C",
        position_group: "OL",
    },
    "00-0032243": {
        team: "away_team",
        firstname: "Ali",
        lastname: "Marpet",
        jersey_number: 74,
        position: "G",
        position_group: "OL",
    },
    "00-0019596": {
        team: "away_team",
        firstname: "Tom",
        lastname: "Brady",
        jersey_number: 12,
        position: "QB",
        position_group: "QB",
    },
    "00-0032217": {
        team: "away_team",
        firstname: "Donovan",
        lastname: "Smith",
        jersey_number: 76,
        position: "T",
        position_group: "OL",
    },
    "00-0036406": {
        team: "away_team",
        firstname: "Tristan",
        lastname: "Wirfs",
        jersey_number: 78,
        position: "T",
        position_group: "OL",
    },
    "00-0027656": {
        team: "away_team",
        firstname: "Rob",
        lastname: "Gronkowski",
        jersey_number: 87,
        position: "TE",
        position_group: "TE",
    },
    "00-0034678": {
        team: "away_team",
        firstname: "Alex",
        lastname: "Cappa",
        jersey_number: 65,
        position: "G",
        position_group: "OL",
    },
    "00-0035298": {
        team: "away_team",
        firstname: "Scott",
        lastname: "Miller",
        jersey_number: 10,
        position: "WR",
        position_group: "WR",
    },
    "00-0027948": {
        team: "away_team",
        firstname: "Blaine",
        lastname: "Gabbert",
        jersey_number: 11,
        position: "QB",
        position_group: "QB",
    },
    "00-0034816": {
        team: "away_team",
        firstname: "Ronald",
        lastname: "Jones",
        jersey_number: 27,
        position: "RB",
        position_group: "RB",
    },
    "00-0032419": {
        team: "away_team",
        firstname: "Joe",
        lastname: "Haeg",
        jersey_number: 73,
        position: "T",
        position_group: "OL",
    },
    "00-0031408": {
        team: "away_team",
        firstname: "Mike",
        lastname: "Evans",
        jersey_number: 13,
        position: "WR",
        position_group: "WR",
    },
    "00-0031273": {
        team: "away_team",
        firstname: "Cameron",
        lastname: "Brate",
        jersey_number: 84,
        position: "TE",
        position_group: "TE",
    },
    "00-0033856": {
        team: "away_team",
        firstname: "Leonard",
        lastname: "Fournette",
        jersey_number: 28,
        position: "RB",
        position_group: "RB",
    },
    "00-0033196": {
        team: "away_team",
        firstname: "Zach",
        lastname: "Triner",
        jersey_number: 97,
        position: "LS",
        position_group: "SPEC",
    },
    "00-0030829": {
        team: "away_team",
        firstname: "Josh",
        lastname: "Wells",
        jersey_number: 72,
        position: "T",
        position_group: "OL",
    },
    "00-0032065": {
        team: "away_team",
        firstname: "Bradley",
        lastname: "Pinion",
        jersey_number: 8,
        position: "P",
        position_group: "SPEC",
    },
    "00-0026968": {
        team: "away_team",
        firstname: "Ryan",
        lastname: "Succop",
        jersey_number: 3,
        position: "K",
        position_group: "SPEC",
    },
    "00-0030386": {
        team: "away_team",
        firstname: "William",
        lastname: "Gholston",
        jersey_number: 92,
        position: "DE",
        position_group: "DL",
    },
    "00-0034613": {
        team: "away_team",
        firstname: "Tanner",
        lastname: "Hudson",
        jersey_number: 88,
        position: "TE",
        position_group: "TE",
    },
    "00-0035681": {
        team: "away_team",
        firstname: "Mike",
        lastname: "Edwards",
        jersey_number: 32,
        position: "FS",
        position_group: "DB",
    },
    "00-0035239": {
        team: "away_team",
        firstname: "Sean",
        lastname: "Murphy-Bunting",
        jersey_number: 23,
        position: "CB",
        position_group: "DB",
    },
    "00-0033595": {
        team: "away_team",
        firstname: "Pat",
        lastname: "O'Connor",
        jersey_number: 79,
        position: "DE",
        position_group: "DL",
    },
    "00-0034778": {
        team: "away_team",
        firstname: "Carlton",
        lastname: "Davis",
        jersey_number: 24,
        position: "CB",
        position_group: "DB",
    },
    "00-0035707": {
        team: "away_team",
        firstname: "Devin",
        lastname: "White",
        jersey_number: 45,
        position: "ILB",
        position_group: "LB",
    },
    "00-0029562": {
        team: "away_team",
        firstname: "Lavonte",
        lastname: "David",
        jersey_number: 54,
        position: "ILB",
        position_group: "LB",
    },
    "00-0034374": {
        team: "away_team",
        firstname: "Jordan",
        lastname: "Whitehead",
        jersey_number: 33,
        position: "SS",
        position_group: "DB",
    },
    "00-0035699": {
        team: "away_team",
        firstname: "Jamel",
        lastname: "Dean",
        jersey_number: 35,
        position: "CB",
        position_group: "DB",
    },
    "00-0027855": {
        team: "away_team",
        firstname: "Ndamukong",
        lastname: "Suh",
        jersey_number: 93,
        position: "DE",
        position_group: "DL",
    },
    "00-0031957": {
        team: "away_team",
        firstname: "Rakeem",
        lastname: "Nunez-Roches",
        jersey_number: 56,
        position: "DT",
        position_group: "DL",
    },
    "00-0036411": {
        team: "away_team",
        firstname: "Antoine",
        lastname: "Winfield",
        jersey_number: 31,
        position: "FS",
        position_group: "DB",
    },
    "00-0027867": {
        team: "away_team",
        firstname: "Jason",
        lastname: "Pierre-Paul",
        jersey_number: 90,
        position: "OLB",
        position_group: "LB",
    },
    "00-0031101": {
        team: "away_team",
        firstname: "Shaquil",
        lastname: "Barrett",
        jersey_number: 58,
        position: "OLB",
        position_group: "LB",
    },
    "00-0026564": {
        team: "away_team",
        firstname: "Steve",
        lastname: "McLendon",
        jersey_number: 96,
        position: "NT",
        position_group: "DL",
    },
    "00-0036450": {
        team: "away_team",
        firstname: "Ke'Shawn",
        lastname: "Vaughn",
        jersey_number: 30,
        position: "RB",
        position_group: "RB",
    },
    "00-0027029": {
        team: "away_team",
        firstname: "LeSean",
        lastname: "McCoy",
        jersey_number: 25,
        position: "RB",
        position_group: "RB",
    },
    "00-0026950": {
        team: "away_team",
        firstname: "A.Q.",
        lastname: "Shipley",
        jersey_number: 62,
        position: "C",
        position_group: "OL",
    },
    "00-0036400": {
        team: "home_team",
        firstname: "Cam",
        lastname: "Brown",
        jersey_number: 47,
        position: "OLB",
        position_group: "LB",
    },
    "00-0031596": {
        team: "home_team",
        firstname: "David",
        lastname: "Mayo",
        jersey_number: 55,
        position: "ILB",
        position_group: "LB",
    },
    "00-0034974": {
        team: "home_team",
        firstname: "Julian",
        lastname: "Love",
        jersey_number: 20,
        position: "FS",
        position_group: "DB",
    },
    "00-0026858": {
        team: "home_team",
        firstname: "Graham",
        lastname: "Gano",
        jersey_number: 5,
        position: "K",
        position_group: "SPEC",
    },
    "00-0035633": {
        team: "home_team",
        firstname: "Corey",
        lastname: "Ballentine",
        jersey_number: 25,
        position: "CB",
        position_group: "DB",
    },
    "00-0036084": {
        team: "home_team",
        firstname: "Madre",
        lastname: "Harper",
        jersey_number: 45,
        position: "DB",
        position_group: "DB",
    },
    "00-0034167": {
        team: "home_team",
        firstname: "Devante",
        lastname: "Downs",
        jersey_number: 52,
        position: "ILB",
        position_group: "LB",
    },
    "00-0036404": {
        team: "home_team",
        firstname: "T.J.",
        lastname: "Brunson",
        jersey_number: 35,
        position: "ILB",
        position_group: "LB",
    },
    "00-0036402": {
        team: "home_team",
        firstname: "Carter",
        lastname: "Coughlin",
        jersey_number: 49,
        position: "OLB",
        position_group: "LB",
    },
    "00-0029570": {
        team: "home_team",
        firstname: "Nate",
        lastname: "Ebner",
        jersey_number: 43,
        position: "SS",
        position_group: "DB",
    },
    "00-0032813": {
        team: "home_team",
        firstname: "Elijhaa",
        lastname: "Penny",
        jersey_number: 39,
        position: "FB",
        position_group: "RB",
    },
    "00-0035683": {
        team: "home_team",
        firstname: "Dexter",
        lastname: "Lawrence",
        jersey_number: 97,
        position: "DE",
        position_group: "DL",
    },
    "00-0033883": {
        team: "home_team",
        firstname: "Jabrill",
        lastname: "Peppers",
        jersey_number: 21,
        position: "SS",
        position_group: "DB",
    },
    "00-0034780": {
        team: "home_team",
        firstname: "Isaac",
        lastname: "Yiadom",
        jersey_number: 27,
        position: "CB",
        position_group: "DB",
    },
    "00-0033546": {
        team: "home_team",
        firstname: "Dalvin",
        lastname: "Tomlinson",
        jersey_number: 94,
        position: "NT",
        position_group: "DL",
    },
    "00-0032890": {
        team: "home_team",
        firstname: "James",
        lastname: "Bradberry",
        jersey_number: 24,
        position: "CB",
        position_group: "DB",
    },
    "00-0030411": {
        team: "home_team",
        firstname: "Logan",
        lastname: "Ryan",
        jersey_number: 23,
        position: "FS",
        position_group: "DB",
    },
    "00-0031933": {
        team: "home_team",
        firstname: "Leonard",
        lastname: "Williams",
        jersey_number: 99,
        position: "DT",
        position_group: "DL",
    },
    "00-0032408": {
        team: "home_team",
        firstname: "Blake",
        lastname: "Martinez",
        jersey_number: 54,
        position: "ILB",
        position_group: "LB",
    },
    "00-0032955": {
        team: "home_team",
        firstname: "Kyler",
        lastname: "Fackrell",
        jersey_number: 51,
        position: "OLB",
        position_group: "LB",
    },
    "00-0034445": {
        team: "home_team",
        firstname: "Nick",
        lastname: "Gates",
        jersey_number: 65,
        position: "C",
        position_group: "OL",
    },
    "00-0034588": {
        team: "home_team",
        firstname: "Trent",
        lastname: "Harris",
        jersey_number: 93,
        position: "OLB",
        position_group: "LB",
    },
    "00-0036394": {
        team: "home_team",
        firstname: "Darnay",
        lastname: "Holmes",
        jersey_number: 30,
        position: "CB",
        position_group: "DB",
    },
    "00-0027975": {
        team: "home_team",
        firstname: "Jabaal",
        lastname: "Sheard",
        jersey_number: 91,
        position: "DE",
        position_group: "DL",
    },
    "00-0032763": {
        team: "home_team",
        firstname: "Austin",
        lastname: "Johnson",
        jersey_number: 98,
        position: "NT",
        position_group: "DL",
    },
    "00-0034800": {
        team: "home_team",
        firstname: "B.J.",
        lastname: "Hill",
        jersey_number: 95,
        position: "DT",
        position_group: "DL",
    },
    "00-0034988": {
        team: "home_team",
        firstname: "Kaden",
        lastname: "Smith",
        jersey_number: 82,
        position: "TE",
        position_group: "TE",
    },
    "00-0030443": {
        team: "home_team",
        firstname: "Levine",
        lastname: "Toilolo",
        jersey_number: 85,
        position: "TE",
        position_group: "TE",
    },
    "00-0028087": {
        team: "home_team",
        firstname: "Dion",
        lastname: "Lewis",
        jersey_number: 33,
        position: "RB",
        position_group: "RB",
    },
    "00-0033881": {
        team: "home_team",
        firstname: "Evan",
        lastname: "Engram",
        jersey_number: 88,
        position: "TE",
        position_group: "TE",
    },
    "00-0035710": {
        team: "home_team",
        firstname: "Daniel",
        lastname: "Jones",
        jersey_number: 8,
        position: "QB",
        position_group: "QB",
    },
    "00-0036397": {
        team: "home_team",
        firstname: "Shane",
        lastname: "Lemieux",
        jersey_number: 66,
        position: "G",
        position_group: "OL",
    },
    "00-0032385": {
        team: "home_team",
        firstname: "Sterling",
        lastname: "Shepard",
        jersey_number: 87,
        position: "WR",
        position_group: "WR",
    },
    "00-0033950": {
        team: "home_team",
        firstname: "Wayne",
        lastname: "Gallman",
        jersey_number: 22,
        position: "RB",
        position_group: "RB",
    },
    "00-0029592": {
        team: "home_team",
        firstname: "Kevin",
        lastname: "Zeitler",
        jersey_number: 70,
        position: "G",
        position_group: "OL",
    },
    "00-0031067": {
        team: "home_team",
        firstname: "Cameron",
        lastname: "Fleming",
        jersey_number: 75,
        position: "T",
        position_group: "OL",
    },
    "00-0036386": {
        team: "home_team",
        firstname: "Andrew",
        lastname: "Thomas",
        jersey_number: 78,
        position: "T",
        position_group: "OL",
    },
    "00-0035535": {
        team: "home_team",
        firstname: "Darius",
        lastname: "Slayton",
        jersey_number: 86,
        position: "WR",
        position_group: "WR",
    },
    "00-0027891": {
        team: "home_team",
        firstname: "Golden",
        lastname: "Tate",
        jersey_number: 15,
        position: "WR",
        position_group: "WR",
    },
    "00-0035869": {
        team: "home_team",
        firstname: "Austin",
        lastname: "Mack",
        jersey_number: 81,
        position: "WR",
        position_group: "WR",
    },
    "00-0032943": {
        team: "home_team",
        firstname: "Riley",
        lastname: "Dixon",
        jersey_number: 9,
        position: "P",
        position_group: "SPEC",
    },
    "00-0030957": {
        team: "home_team",
        firstname: "Casey",
        lastname: "Kreiter",
        jersey_number: 58,
        position: "LS",
        position_group: "SPEC",
    },
    "00-0027688": {
        team: "home_team",
        firstname: "Colt",
        lastname: "McCoy",
        jersey_number: 12,
        position: "QB",
        position_group: "QB",
    },
    "00-0036392": {
        team: "home_team",
        firstname: "Matt",
        lastname: "Peart",
        jersey_number: 74,
        position: "T",
        position_group: "OL",
    },
    "00-0032911": {
        team: "home_team",
        firstname: "Spencer",
        lastname: "Pulley",
        jersey_number: 77,
        position: "C",
        position_group: "OL",
    },
    "00-0031928": {
        team: "home_team",
        firstname: "Chad",
        lastname: "Slade",
        jersey_number: 62,
        position: "G",
        position_group: "OL",
    },
    "00-0029141": {
        team: "home_team",
        firstname: "Alfred",
        lastname: "Morris",
        jersey_number: 41,
        position: "RB",
        position_group: "RB",
    },
    "00-0035339": {
        team: "home_team",
        firstname: "Montre",
        lastname: "Hartage",
        jersey_number: 36,
        position: "SS",
        position_group: "DB",
    }
};
for (const p of Object.values(players)) {
    const img = new Image();
    img.src = mugshotSrc(p);
}
